import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";
import Label from "../../../ui/components/Label/Label";

import ArtifactProductionStatusLabel from "./ArtifactProductionStatusLabel";
import ArtifactValidationStatusLabel from "./ArtifactValidationStatusLabel";

export default function ArtifactStatusLabels({ artifact, production }) {
	const { t } = useTranslation();

	if (artifact.deleted) {
		return <Label color="red">{t("deleted", "Deleted")}</Label>;
	}

	return (
		<div>
			<Flex gap={5} style={{ whiteSpace: "nowrap" }}>
				<ArtifactValidationStatusLabel artifact={artifact} />

				{production && <ArtifactProductionStatusLabel artifact={artifact} />}
			</Flex>
		</div>
	);
}
